import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "contactName",
  "use": "contactName-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"contactName\"><defs><style>#contactName .cls-1{fill:none}</style></defs><title>资源 65</title><g id=\"contactName_图层_2\" data-name=\"图层 2\"><g id=\"contactName_图层_1-2\" data-name=\"图层 1\"><path id=\"contactName_Rectangle_43_Copy_12\" data-name=\"Rectangle 43 Copy 12\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"contactName_user\"><path id=\"contactName_Shape\" d=\"M19 22.5a.84.84 0 0 1-.84-.85 6.14 6.14 0 0 0-12.27 0 .84.84 0 1 1-1.68.06v-.06A7.83 7.83 0 0 1 9 14.45a8.52 8.52 0 0 1 1-.33 6.46 6.46 0 1 1 6.64-1.56 6.5 6.5 0 0 1-2.5 1.55 8.1 8.1 0 0 1 1 .34 7.86 7.86 0 0 1 4.15 4.16 7.77 7.77 0 0 1 .62 3.05.84.84 0 0 1-.91.84zM12 3.23A4.77 4.77 0 1 0 16.77 8 4.78 4.78 0 0 0 12 3.23z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/contactName.svg
// module id = hXVo
// module chunks = 6